<template>
  <v-container>
    <v-stepper-header class="elevation-0">
      <template class="d-flex" v-for="(step, index) in steps">
        <v-stepper-step
          :key="'step-' + index"
          :color="stepperStep === index + 1 ? 'primary' : 'success'"
          :class="[
            'text-body-2',
            'stepper__steps',
            index === 0 && 'pl-0',
            index === steps.length - 1 && 'pr-0',
          ]"
          :complete="stepperStep > index + 1"
          :step="index + 1"
          >{{ $t(step) }}</v-stepper-step
        >
        <v-divider
          :key="'divider-' + index"
          class="stepper__steps-divider"
          v-show="index !== steps.length - 1"
        />
      </template>
    </v-stepper-header>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { OFFER_TYPE } from '@/helpers/constants'

export default {
  name: 'StepperHeader',
  props: ['stepperStep', 'offerType'],
  data() {
    return {
      baseSteps: [
        'STEPPER_STEPINIT_LABEL',
        'STEPPER_STEP1_LABEL',
        'ADDITIONAL_SERV_LABEL',
        'STEPPER_STEP3_LABEL',
        'STEPPER_STEP6_LABEL',
      ],
      advancedSteps: [
        'STEPPER_STEPINIT_LABEL',
        'STEPPER_STEP1_LABEL',
        'ADDITIONAL_SERV_LABEL',
        'STEPPER_STEP3_LABEL',
        'STEPPER_STEP4_LABEL',
        'STEPPER_STEP5_LABEL',
        'STEPPER_STEP6_LABEL',
      ],
      phantomSteps: ['STEPPER_STEPINIT_LABEL', 'STEPPER_STEP6_LABEL'],
    }
  },
  computed: {
    ...mapGetters('rateModel', ['isTypeBroker']),
    steps() {
      return this.offerType === OFFER_TYPE.F
        ? this.phantomSteps
        : this.offerType === OFFER_TYPE.A || this.isTypeBroker
        ? this.baseSteps
        : this.advancedSteps
    },
  },
}
</script>

<style scoped lang="scss">
.stepper {
  &__steps {
    @include short-desktop {
      padding-top: rem(4);
    }
    &-divider {
      @include short-desktop {
        margin-bottom: rem(20) !important;
      }
    }
  }
}
</style>
